import { Component, computed, inject, Injector, signal, OnInit, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { FiItemsListType } from '@fi-app/shared/fi-items-list/fi-items-list-type';
import { FiDisplayType } from '@fi-app/shared/types/display-type';
import { UserPreferencesService } from '@fi-shared/fi-shared-services/user-preferences.service';

@Component({
    selector: 'fi-document-navigation-tabs',
    templateUrl: './document-navigation-tabs.component.html',
    styleUrls: ['./document-navigation-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-document-navigation-tabs' },
    standalone: false,
})
export class DocumentNavigationTabsComponent extends TabsModuleBase implements OnInit {
    private userPreferencesService = inject(UserPreferencesService);
    private appTextService = inject(AppTextService);
    protected currentListDisplayType = signal<FiDisplayType>(
        this.userPreferencesService.getListDisplayType(FiItemsListType.Documents) ?? FiDisplayType.List,
    );
    protected isCurrentListDisplayTypeList = computed(() => this.currentListDisplayType() === FiDisplayType.List);

    constructor(injector: Injector) {
        super(injector);
    }

    public ngOnInit(): void {
        const hasWriteAccessRight = this.stateAccessCheckService.isStateAllowedForCurrentUser(
            FiStateNames.Document.Edit,
        );

        this.tabs.push({
            Title: this.appTextService.get('common.pages'),
            Sref: FiStateNames.Document.List,
            AddState: FiStateNames.Document.Add,
        });

        if (hasWriteAccessRight)
            this.tabs.push({
                Title: this.appTextService.get('templates'),
                Sref: FiStateNames.Document.Template.List,
                AddState: FiStateNames.Document.Template.Add,
            });

        super.updateSelectedTabFromState();
    }

    protected updateCurrentListDisplayType(type: number): void {
        this.currentListDisplayType.set(type);
        this.userPreferencesService.saveListDisplayType(FiItemsListType.Documents, type);
    }

    isCurrentStateTemplate(): boolean {
        return this.stateService.current.name === FiStateNames.Document.Template.List;
    }
}
